"use client";

import styles from "./CasesServices.module.scss";
import CasesGrid from "@/components/Cases/CasesGrid/CasesGrid";
import { TitleAnimation } from "@/components/common/TitleAnimation/TitleAnimation";

export default function CasesServices({ messages, projectsList }) {
  return (
    <section className={styles.casesContainer}>
      <div className="container">
        <TitleAnimation
          messages={{
            first_word: messages?.first_word || "",
            second_word: messages?.second_word || "",
            third_word: messages?.last_word || "",
          }}
          lastWords={styles.lastWords}
          isSmall
        />
        <CasesGrid projects={projectsList} />
      </div>
    </section>
  );
}
